module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/modules/$.library.js
// module id = 714
// module chunks = 17